import { useState } from "react";
import DashboardShell from "../../components/ui/DashboardShell";
import Sidebar from "../Components/Sidebar";
import Topbar from "../Components/Topbar";

export default function DashboardLayout({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved === "true";
  });

  const toggleCollapsed = (value) => {
    setCollapsed(value);
    localStorage.setItem("sidebarCollapsed", value);
  };

  return <DashboardShell Sidebar={Sidebar} Topbar={Topbar} collapsed={collapsed} setCollapsed={toggleCollapsed}>
    {children}
  </DashboardShell>;
}
